module.exports = __webpack_public_path__ + "img/bingo_ball-64.24f153fc.png";